module.exports = __webpack_public_path__ + "media/src/images/zu_teaching01_page-d9ced088053b1873395b00b79eb295cc.png";